import React from 'react';

import {FIND_ALL_PROFISSIONAIS_SAUDE as query} from '../../../graphql/queries';
import {SelectBase} from './select-apollo';

const getVariables = ({pageNumber, search = '', pageSize = 20}) => {
  return {
    pageable: {pageNumber, pageSize, sortField: 'nome', sortDir: 'ASC'},
    searchDTO: {search},
  };
};

export const SelectProfissionais = (props) => {
  return (
    <SelectBase
      responseObjectName="profissionais"
      labelProp="nome"
      query={query}
      getVariables={getVariables}
      {...props}
    />
  );
};
